var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',[_c('b-alert',{attrs:{"show":_vm.localDismissCountDown,"dismissible":"","variant":_vm.variant},on:{"dismissed":_vm.onDismissed,"dismiss-count-down":_vm.countDownChanged}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }